module.exports = __webpack_public_path__ + "static/media/business-owner-Google-Search-1.424706a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/business/business-owner-Google-Search-1.jpg
// module id = 768
// module chunks = 0